import { APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { ApolloClientOptions, ApolloLink, InMemoryCache } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { environment } from '../environments/environment';

export function createApollo(httpLink: HttpLink): ApolloClientOptions<any> {
  // Create the http link with Hygraph API endpoint
  const http = httpLink.create({
    uri: environment.hygraph.apiEndpoint,
  });

  // Auth link to add Hygraph authentication
  const auth = setContext((_, { headers }) => {
    return {
      headers: {
        ...headers,
        // Content API token from environment variables
        Authorization: `Bearer ${environment.hygraph.contentApiToken}`,
      }
    };
  });

  return {
    link: ApolloLink.from([auth, http]),
    cache: new InMemoryCache({
      typePolicies: {
        // Hygraph specific type policies
        Asset: {
          keyFields: ["id"],
        },
        MethodologyPage: {
          keyFields: ["id"],
        },
        BenefitItem: {
          keyFields: ["id"],
        },
        PrincipleItem: {
          keyFields: ["id"],
        }
      }
    }),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'cache-and-network', // Good balance for Hygraph content
        errorPolicy: 'all',
      },
      query: {
        fetchPolicy: 'cache-first', // Good for static content
        errorPolicy: 'all',
      },
    }
  };
}

export const APOLLO_PROVIDER = {
  provide: APOLLO_OPTIONS,
  useFactory: createApollo,
  deps: [HttpLink],
};